<template>
  <path
    d="M2 17.0002C2 17.5502 2.45 18.0002 3 18.0002H21C21.55 18.0002 22 17.5502 22 17.0002C22 16.4502 21.55 16.0002 21 16.0002H3C2.45 16.0002 2 16.4502 2 17.0002ZM2 12.0002C2 12.5502 2.45 13.0002 3 13.0002H21C21.55 13.0002 22 12.5502 22 12.0002C22 11.4502 21.55 11.0002 21 11.0002H3C2.45 11.0002 2 11.4502 2 12.0002ZM2 7.00018C2 7.55018 2.45 8.00018 3 8.00018H21C21.55 8.00018 22 7.55018 22 7.00018C22 6.45018 21.55 6.00018 21 6.00018H3C2.45 6.00018 2 6.45018 2 7.00018Z"
  />
</template>
